<template>
  <c-modal
    :title="title"
    :active="active"
    class="c-imageCropper"
    @close="doCancel"
    @opened="initCroppie"
  >
    <b-loading
      :is-full-page="false"
      :active.sync="isLoading"
    />
    <div
      :style="{ paddingBottom: isLoading ? `calc(${height / width * 100}% + 55px)` : 0 }"
      class="c-imageCropper_body"
      ref="body"
    >
      <div ref="croppie"></div>
    </div>
    <div
      slot="footer"
      class="c-imageCropper_footer"
    >
      <div class="c-imageCropper_rotate">
        <c-button @click="doRotate">
          <b-icon icon="autorenew" size="is-small" /><span>回転</span>
        </c-button>
      </div>
      <div class="c-imageCropper_control">
        <c-button @click="doCancel">キャンセル</c-button>
        <c-button color="primary" @click="doCrop">決定</c-button>
      </div>
    </div>
  </c-modal>
</template>
<script>
// NOTE: 縦長未対応

if (process.browser) {
  // XXX: 最新版（croppie@2.6.2）は、画像の回転時に幅の再計算が意図通り行われないため、@2.4.1で固定すること
  let Croppie = require('croppie')
}

// constants
const ROTATE_ORIENTATIONS = Object.freeze([1, 6, 3, 8])
const BOUNDARY_PADDING = 40 // NOTE: 境界の余白

export default {
  name: 'ImageCropper',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    path: {
      type: String
    },
    width: {
      type: Number,
      default: 500
    },
    height: {
      type: Number,
      default: 300
    },
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    enableResize: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '画像を編集する'
    }
  },
  data() {
    return {
      orientation: 1,
      orientationIndex: 0,
      croppieData: {},
      bodyWidth: 0,
      isLoading: false,
      newDataUri: null
    }
  },
  methods: {
    initCroppie() {
      let vm = this
      this.bodyWidth = this.$refs.body.offsetWidth
      this.croppie = new Croppie(this.$refs.croppie, {
        format: 'jpeg',
        viewport: { width: this.maxWidth, height: this.maxHeight },
        boundary: { width: this.boundaryWidth, height: this.boundaryHeight },
        enableOrientation: true,
        update(data) {
          vm.croppieData = data
        }
      })
      this.$util.on('update', this.$refs.croppie, this.onUpdate)
      this.bindCroppie()
      this.isLoading = false
    },
    onUpdate() {
      this.croppie
        .result({
          type: 'base64',
          format: 'jpeg',
          size: this.enableResize ? 'viewport' : 'original',
          backgroundColor: this.backgroundColor
        })
        .then(dataUri => {
          this.newDataUri = dataUri
          this.$emit('update', dataUri)
        })
    },
    doCrop() {
      this.$emit('cropped', this.newDataUri)
    },
    doCancel() {
      this.$emit('cancel')
      this.close()
    },
    close() {
      this.$emit('update:active', false)
    },
    doRotate() {
      // NOTE: croppie標準のrotateメソッドはバグってるので毎回bindし直すことで回転させる
      this.orientationIndex++
      if (this.orientationIndex >= ROTATE_ORIENTATIONS.length) {
        this.orientationIndex = 0
      }
      this.orientation = ROTATE_ORIENTATIONS[this.orientationIndex]
      // 再バインド
      this.bindCroppie()
    },
    bindCroppie(zoom = 0) {
      this.croppie
        .bind({
          url: this.path,
          orientation: this.orientation
        })
        .then(() => {
          this.croppie.setZoom(zoom)
        })
    }
  },
  watch: {
    active(v) {
      if (v) {
        this.isLoading = true
      }
      this.$emit('update:active', v)
    }
  },
  computed: {
    aspectRatio() {
      return this.maxWidth / this.width
    },
    boundaryPadding() {
      if (['sp'].includes(this.$store.state.ui.viewport.device)) {
        return BOUNDARY_PADDING / 2
      }
      return BOUNDARY_PADDING
    },
    maxWidth() {
      return this.bodyWidth < this.width + this.boundaryPadding
        ? this.bodyWidth - this.boundaryPadding
        : this.width
    },
    maxHeight() {
      return this.aspectRatio * this.height
    },
    boundaryWidth() {
      return this.maxWidth + this.boundaryPadding
    },
    boundaryHeight() {
      return this.maxHeight + this.boundaryPadding
    }
  }
}
</script>
<style src="~/node_modules/croppie/croppie.css">
</style>
<style lang="scss" scoped>
//@import '~/node_modules/croppie/croppie.css';
.c-imageCropper {
  &_body {
    width: 100%;
    position: relative;
  }
  &_footer {
    display: flex;
    justify-content: space-between;
  }
  &_rotate {
  }
  &_control {
    .button + .button {
      margin-left: 0.5em;
    }
  }
}

/deep/ .c-modal_body {
  padding: 0;
}
</style>
